import React, { Component } from 'react';
import Botao from './Botao';
import { EditNote } from '@mui/icons-material';

class BotaoAssinar extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div title={this.props.disabled ? "Assinatura não disponível no seu perfil" : "Assinar minutas"}>
                <Botao label="Assinar"
                    redirectTo="/escaninho/assinatura"
                    pathnameConfig={['/adicionarControleGabinete', '/configuracaoGabinete']}
                    disabled={this.props.disabled}
                    startIcon={<EditNote/>}
                />
            </div>
        );
    }
}

export default BotaoAssinar;